<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        class="woom-bike-outline woom-original-1"
        viewBox="0 0 800 600"
        style="enable-background: new 0 0 800 600"
        xml:space="preserve"
        v-once>
        <g class="bike">
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M279.9,403.4c-6.8,59.4-57.2,104.9-118.4,104.9s-119.3-53.4-119.3-119.3,53.4-119.3,119.3-119.3,111.5,45.4,118.4,104.8" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M280,402.9" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M249.6,403c-6.5,42.8-43.5,75.2-88.1,75.2s-89.2-39.9-89.2-89.2,39.9-89.2,89.2-89.2,81.4,32.5,88.1,75.1" />
            </g>
            <g>
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M602.8,275.1c11.4-3.6,23.1-5.3,35.7-5.3,65.9,0,119.3,53.4,119.3,119.3s-53.4,119.3-119.3,119.3-119.2-53.5-119.2-119.4,20.9-77.8,53-99.2" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M572.6,289.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M585.8,317.1" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M615.7,302.8c7.3-2,14.8-2.9,22.8-2.9,49.2,0,89.2,39.9,89.2,89.2s-39.9,89.2-89.2,89.2-89.2-39.9-89.2-89.2,14.1-55.6,36.3-71.8" />
            </g>
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M185.1,402.6l-17-2.1s-2.6.3-2.6-3.4v-8.3s-.9-4.3-4.3-4.3-4.4,3.3-4.4,4.3-.1,7.2-.1,7.2c0,0-2.1,3.2-3.6.5s-5.2-8.3-.7-13.9c2.5-4,7.4-4.4,7.4-4.4l24.2-3.1h70l87.3-.7s8.8,2.2,14.6,1.9,11-2.6,11-2.6c0,0,17.3.8,33.8-4.3,16.6-5.1,31-14.8,31-14.8,0,0,17.7-11.9,28-30.9s50.2-92.6,50.2-92.6l20.6-38.1s-3.1-4.7-4.5-7.6c-1.5-2.9-2.5-6.3-2.5-6.3l35.8-14.8s2,2.6,2.9,7.2c.9,4.7,1.5,9,3.3,12.4s16.9,40.5,16.9,40.5c0,0,3.7,5.2,4.5,7.1.9,1.9,2,4.6,2,4.6l-36.7,14.8s-1.7-3.3-2.4-7.1-1.7-9-2.6-9.6c-2,3.8-52.1,96.1-52.1,96.1,0,0-11.9,23.8-23.9,34.9-11.9,11.1-19.9,17.3-19.9,17.3,0,0-14.5,12.6-41.5,18.5-21,4.3-33.1,3.1-33.1,3.1,0,0-7.1-3.3-13.8-2.8-6.7.5-12.3,2.1-12.3,2.1l-165.5-.8h0Z" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="341.7 374.3 328.4 335 352.3 327.5 367 373.7" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M350.9,403.2" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="377 404.6 381.2 417.5 355.4 417.5 351.1 403.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M367.1,373.9" />
            <g class="saddle-normal">
                <polygon
                    class="fill-none stroke-woom-black stroke-2"
                    points="358.5 417.6 362.8 431.3 380.9 425.4 378.4 417.6 358.5 417.6" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="314.6 283.9 331.1 333.8 349.4 327.8 333.1 278.1" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M307.4,275.2l3.6,10.9,2.4-.8s3.6-5.4,9.3-6.8c5.6-1.5,12.8-.2,12.8-.2l2.1-.7-2-6.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M346.3,267.6s20.3-6.6,32.6-10.7c12.3-4,18.8-5.5,19.9-5.9s3.5-1,1-6.9-7.9-12.6-21.3-11.5-20,6.4-37.5,8.6c-17.6,2.2-31.3,2.7-45.7-.5-14.4-3.2-30.4-7.6-31.2-7.8s-9.4-3.3-14,5.4-4.4,13.5-4.1,15.7c.3,2.2,1.3,7.3,8.4,10.3,7.1,3,27.5,8.5,37.7,9.5s18.9,2.4,32.6-.2c13.4-2.5,21.6-6,21.6-6h0Z" />
            </g>
            <polygon
                class="fill-none stroke-woom-black stroke-2"
                points="519.3 168.3 549.2 156.1 558.9 161.8 559.5 164.4 523.7 179.2 519.3 168.3" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M556,104.7s4.9,3.4,5.9,7.5,2.1,19.1,2.3,20.4c.2,1.2,1.4,5.5-1.4,10.5s-10,6.9-12.8,9.2-.8,3.8-.8,3.8l-29.9,12.2-5.4-13s2.5-7.5,2.7-7.7l26.5-16.2.2-4.9" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M538.1,96.7" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M537.6,125.8" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M538.1,96.7c1.2-.3,2.5-.5,3.9-.5,8.4,0,15.2,6.8,15.2,15.2s-6.8,15.2-15.2,15.2-3-.2-4.4-.7" />
            <circle
                class="fill-none stroke-woom-black stroke-2"
                cx="525.2"
                cy="111"
                r="19.3" />
            <polyline
                class="fill-none stroke-woom-black stroke-2"
                points="567.3 279.4 565.2 279.3 552.4 251.1 589 236.3 599.6 265.3 598.6 266.6" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M562.8,269s23.1,49.5,27,56.3,26.9,45.4,26.9,45.4l1.5-.7,20.2-9.7s-19.1-50.3-21.1-54.4-24-50.5-24-50.5c0,0-5-6.4-18.6-.9s-11.9,14.5-11.9,14.5h0Z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M618.4,374.6l9.5,20.3s4.8,7.2,9.4,6.3c2.8-.6.3-4.4.3-4.4l-3.3-7.1s-1.2-3,2.1-4.6c3.3-1.5,5.3.7,5.8,1.5s4.5,9,4.5,9c0,0,1.2,2,2.4-.9,1.2-3,2.6-5.2.3-11.1-2.3-5.8-9.2-19.2-9.2-19.2l-3.6-3.3-18.5,8.9.3,4.6h0Z" />
            <path
                class="fill-none stroke-woom-black stroke-2"
                d="M521,271.7l-.9,1.1c-.2.2-.4.3-.8.2l-8.3-3c-2.8-1-5.8-.5-7.9,2.2-1,1.3-1.5,3-1.4,4.7-1.9.3-3.5,1.4-4.4,2.6-2.2,2.8-2.3,5.9-.5,8.2-3.1-.5-6.4.6-8.5,3.3-2,2.5-2.4,5.9-1.3,8.7-3-.4-6.2.8-8.2,3.3s-2.4,5.9-1.3,8.7l-1.7-1.4c-.9-.7-2.3-.6-3,.4-.7.9-.6,2.3.4,3l7.3,5.7c1.1.9,1,2.5.3,3.5-.8,1-2.4,1.4-3.5.6h-.1c0-.1-7.2-5.7-7.2-5.7-.9-.7-2.3-.6-3,.3s-.6,2.3.4,3l7.2,5.6h.1c1.2,1,1,2.6.4,3.5s-1.6,1.3-3.2.7l-9-3.3c-2.2-.8-3.7.5-4.3,1.2l-1.4,1.8c-.7.9-.6,2.2.3,3,.9.7,2.3.5,3-.4l.9-1.1c.2-.2.4-.3.8-.2l8.3,3c2.8,1,5.8.5,7.9-2.2,1-1.3,1.5-3,1.4-4.7,1.9-.3,3.5-1.4,4.4-2.6,2.2-2.8,2.3-5.9.5-8.2,3.1.5,6.4-.6,8.5-3.2,2-2.6,2.4-5.9,1.3-8.7,3,.4,6.2-.8,8.2-3.3,2-2.6,2.4-5.9,1.3-8.7l1.7,1.4c.9.7,2.3.6,3-.4.7-.9.6-2.3-.4-3l-7.3-5.7c-1.1-.9-1-2.5-.3-3.5.8-1,2.4-1.4,3.5-.6h.1c0,.1,7.2,5.7,7.2,5.7.9.7,2.3.6,3-.3s.6-2.3-.4-3l-7.2-5.6h-.1c-1.2-1-1-2.6-.4-3.5s1.6-1.3,3.2-.7l9,3.3c2.2.8,3.7-.5,4.3-1.2l1.4-1.8c.7-.9.6-2.2-.3-3-.9-.8-2.2-.6-3,.3h0ZM489.6,311.4c-1.6,2-4.5,2.4-6.6.8-2-1.6-2.4-4.6-.8-6.6s4.6-2.4,6.6-.8c2.1,1.6,2.4,4.5.8,6.6ZM499.1,299.4c-1.6,2-4.5,2.4-6.6.8-2-1.6-2.4-4.6-.8-6.6s4.6-2.4,6.6-.8c2.1,1.6,2.4,4.5.8,6.6Z" />
        </g>
        <g class="tyres hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="160.9"
                            y1="269.8"
                            x2="160.9"
                            y2="508.3" />
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="153.1"
                                y="268.6"
                                width="15.7"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="153.1"
                                y="507.1"
                                width="15.7"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>

            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="639"
                            y1="269.8"
                            x2="639"
                            y2="508.3" />
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="631.2"
                                y="268.6"
                                width="15.7"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="631.2"
                                y="507.1"
                                width="15.7"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="cockpit hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="524.5"
                            y1="111"
                            x2="524.5"
                            y2="508.3" />
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="516.7"
                                y="109.8"
                                width="15.6"
                                height="2.4" />
                        </g>
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="516.7"
                                y="507.1"
                                width="15.6"
                                height="2.4" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="steering-angle hidden">
            <g class="inline">
                <g>
                    <polyline
                        class="h-line-miter fill-none stroke-woom-red stroke-3"
                        points="509.5 111.4 568.5 237.5 443.4 237.5" />
                </g>
                <path
                    class="h-line-miter fill-none stroke-woom-red stroke-3"
                    d="M519.5,237.3c0-19.5,11.6-36.4,28.2-44" />
            </g>

            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="572.1"
                                y1="245"
                                x2="573.8"
                                y2="248.7" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="577.2"
                                y1="256"
                                x2="691.7"
                                y2="500.9" />
                            <polyline
                                class="h-line fill-none stroke-woom-red stroke-3"
                                points="693.4 504.5 695.1 508.1 691.1 508.1" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="683.3"
                                y1="508.1"
                                x2="577.9"
                                y2="508.1" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="574"
                                y1="508.1"
                                x2="570"
                                y2="508.1" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M645.5,508.3c0-1.3,0-2.7.2-4" />
                        <path
                            class="h-dash-line fill-none stroke-woom-red stroke-3"
                            d="M647.4,495c3.1-10.8,9.8-20.1,18.8-26.4" />
                        <path
                            class="h-line fill-none stroke-woom-red stroke-3"
                            d="M670.2,466.1c1.2-.7,2.3-1.3,3.6-1.8" />
                    </g>
                </g>
            </g>
        </g>
        <g class="top-tube-horizontal hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="535.8"
                            y1="149.1"
                            x2="323.2"
                            y2="149.1" />
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="534.6"
                                y="141.3"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="322"
                                y="141.3"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="wheelbase hidden">
            <g class="inline">
                <g>
                    <g>
                        <line
                            class="h-line fill-none stroke-woom-red stroke-3"
                            x1="638.1"
                            y1="391.1"
                            x2="161.6"
                            y2="391.1" />
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="638.2"
                                y="383.3"
                                width="2.4"
                                height="15.6" />
                        </g>
                        <g>
                            <rect
                                class="fill-woom-red stroke-woom-red"
                                x="160.4"
                                y="383.3"
                                width="2.4"
                                height="15.6" />
                        </g>
                    </g>
                </g>
            </g>
        </g>
        <g class="seat-tube-angle hidden">
            <g>
                <polyline
                    class="h-line fill-none stroke-woom-red stroke-3"
                    points="326 285.4 396.7 508.1 165.6 508.1" />
            </g>
            <path
                class="h-line-miter inline fill-none stroke-woom-red stroke-3"
                d="M349.9,508.2c0-19.5,15.8-36.5,32.4-44.1" />
        </g>

        <g class="min-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="322.4"
                                y1="262.9"
                                x2="318.3"
                                y2="262.9" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="309.9"
                                y1="262.9"
                                x2="31.4"
                                y2="262.9" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="27.3"
                                y1="262.9"
                                x2="23.1"
                                y2="262.9" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="10"
                                    y1="262.9"
                                    x2="10"
                                    y2="508.3" />
                                <g>
                                    <rect
                                        class="fill-woom-red stroke-woom-red"
                                        x="3"
                                        y="261.8"
                                        width="14"
                                        height="2.1" />
                                </g>
                                <g>
                                    <rect
                                        class="fill-woom-red stroke-woom-red"
                                        x="3"
                                        y="507.2"
                                        width="14"
                                        height="2.1" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="inline">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M280,402.9" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="341.7 374.3 328.4 335 352.3 327.5 367 373.7" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M350.9,403.2" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="377 404.6 381.2 417.5 355.4 417.5 351.1 403.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M367.1,373.9" />
                <polygon
                    class="fill-none stroke-woom-black stroke-2"
                    points="358.5 417.6 368.8 449.3 386.9 443.4 378.4 417.6 358.5 417.6" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="320.6 303.9 331.1 333.8 349.4 327.8 339.1 298.1" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M313.4,295.2l3.6,10.9,2.4-.8s3.6-5.4,9.3-6.8c5.6-1.5,12.8-.2,12.8-.2l2.1-.7-2-6.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M352.3,287.6s20.3-6.6,32.6-10.7c12.3-4,18.8-5.5,19.9-5.9,1-.4,3.5-1,1-6.9-2.6-5.9-7.9-12.6-21.3-11.5s-20,6.4-37.5,8.6c-17.6,2.2-31.3,2.7-45.7-.5-14.4-3.2-30.4-7.6-31.2-7.8s-9.4-3.3-14,5.4-4.4,13.5-4.1,15.7,1.3,7.3,8.4,10.3c7.2,3.1,27.5,8.5,37.7,9.5s18.9,2.4,32.6-.2c13.4-2.5,21.6-6,21.6-6Z" />
            </g>
        </g>
        <g class="max-saddle-height hidden">
            <g class="inline">
                <g>
                    <g>
                        <g>
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="305.4"
                                y1="206.9"
                                x2="301.3"
                                y2="206.9" />
                            <line
                                class="h-dash-line fill-none stroke-woom-red stroke-3"
                                x1="293"
                                y1="206.9"
                                x2="31.4"
                                y2="206.9" />
                            <line
                                class="h-line fill-none stroke-woom-red stroke-3"
                                x1="27.3"
                                y1="206.9"
                                x2="23.1"
                                y2="206.9" />
                        </g>
                    </g>
                </g>
                <g>
                    <g>
                        <g>
                            <g>
                                <line
                                    class="h-line fill-none stroke-woom-red stroke-3"
                                    x1="10"
                                    y1="206.9"
                                    x2="10"
                                    y2="508.3" />
                                <g>
                                    <rect
                                        class="fill-woom-red stroke-woom-red"
                                        x="2.2"
                                        y="205.7"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                                <g>
                                    <rect
                                        class="fill-woom-red stroke-woom-red"
                                        x="2.2"
                                        y="507.1"
                                        width="15.6"
                                        height="2.4" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <g class="h-line fill-none stroke-woom-red stroke-3">
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M280,402.9" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="341.7 374.3 328.4 335 352.3 327.5 367 373.7" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M350.9,403.2" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="377 404.6 381.2 417.5 355.4 417.5 351.1 403.6" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M367.1,373.9" />
                <polyline
                    class="fill-none stroke-woom-black stroke-2"
                    points="302.6 247.9 331.1 333.8 349.4 327.8 321.1 242.1" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M295.4,239.2l3.6,10.9,2.4-.8s3.6-5.4,9.3-6.8c5.6-1.5,12.8-.2,12.8-.2l2.1-.7-2-6.4" />
                <path
                    class="fill-none stroke-woom-black stroke-2"
                    d="M334.3,231.6s20.3-6.6,32.6-10.7c12.3-4,18.8-5.5,19.9-5.9s3.5-1,1-6.9-7.9-12.6-21.3-11.5-20,6.4-37.5,8.6c-17.6,2.2-31.3,2.7-45.7-.5-14.4-3.2-30.4-7.6-31.2-7.8s-9.4-3.3-14,5.4-4.4,13.5-4.1,15.7c.3,2.2,1.3,7.3,8.4,10.3,7.2,3.1,27.5,8.5,37.7,9.5,10.1.9,18.9,2.4,32.6-.2,13.4-2.5,21.6-6,21.6-6h0Z" />
            </g>
        </g>
    </svg>
</template>
